export const FILE_REMOVE_UPLOADED = "FILE_REMOVE_UPLOADED";
export const FILE_REMOVE_UPLOADED_SUCCESS = "FILE_REMOVE_UPLOADED_SUCCESS";
export const FILE_REMOVE_UPLOADED_ERROR = "FILE_REMOVE_UPLOADED_ERROR";
export const FILE_DOWNLOAD = "FILE_DOWNLOAD";
export const FILE_DOWNLOAD_SUCCESS = "FILE_DOWNLOAD_SUCCESS";
export const FILE_DOWNLOAD_ERROR = "FILE_DOWNLOAD_ERROR";
export const CHANGE_ARCHIVE = "CHANGE_ARCHIVE";
export const CHANGE_ARCHIVE_SUCCESS = "CHANGE_ARCHIVE_SUCCESS";
export const CHANGE_ARCHIVE_ERROR = "CHANGE_ARCHIVE_ERROR";
